// <pbr-text-club> wraps a Postscript embedded form pasted into the section.
// Postscript owns the whole opt-in: phone → one-time code → success, with
// consent, OTP verification, "already subscribed" handling and reporting all
// inside its own script. This element does two small things:
//   1. Marks the host once the embedded form has mounted, so the card can
//      style around it (a CSS hook, not a layout takeover).
//   2. Re-fires a `pbr:text-club:subscribed` DOM event when the form
//      completes, so any page analytics keep working as they did with the
//      old custom flow.
// Postscript's embedded-form events are documented at
// developers.postscript.io/docs/sdk-events (postscript:embedded-form:
// mount / impression / step-change / complete).

class PbrTextClub extends HTMLElement {
  connectedCallback() {
    this.completed = false;
    this.onFormEvent = (e) => this.handle(e);
    window.addEventListener('postscript:embedded-form', this.onFormEvent);
  }

  disconnectedCallback() {
    window.removeEventListener('postscript:embedded-form', this.onFormEvent);
  }

  handle(event) {
    const detail = event.detail || {};
    const type = String(detail.type || '');

    if (type === 'mount' || type === 'impression') {
      this.dataset.mounted = 'true';
      return;
    }

    if (type === 'complete' && !this.completed) {
      this.completed = true;
      this.dataset.complete = 'true';
      this.dispatchEvent(
        new CustomEvent('pbr:text-club:subscribed', {
          bubbles: true,
          detail: {
            status: detail.subscriberStatus === 'existing' ? 'existing' : 'new',
            subscriberId: detail.subscriberId ?? null,
            source: 'embedded-form',
          },
        })
      );
    }
  }
}

if (!customElements.get('pbr-text-club')) customElements.define('pbr-text-club', PbrTextClub);
